<script lang="ts" setup>
/* eslint-disable vue/no-v-html */

export interface CardGrayItem {
    card_title: string
    card_description: string
}

export interface PagebuilderCardGrayProps {
    data: {
        card: CardGrayItem[]
    }
}

const props = defineProps<PagebuilderCardGrayProps>()
const { $formatTableHtml } = useNuxtApp()
</script>

<template>
  <div class="row g-6 mb-10 mb-md-20">
    <div
      v-for="(item, index) in props.data.card"
      :key="`card-gray-${index}`"
      class="col-12 col-md-6"
    >
      <article class="card-gray rounded p-8 p-md-10 h-100">
        <h3 class="card-gray__title mb-5">
          {{ item.card_title }}
        </h3>
        <Typo>
          <div v-html="$formatTableHtml(item.card_description)" />
        </Typo>
      </article>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import './PagebuilderCardGray.scss';
</style>
